<template>
    <div class="container">
        <div class="row justify-content-center mt-5">

            <connection-api-test-component
                v-if="this.$store.state.errorMessageResponse" :messageResponse="this.$store.state.errorMessageResponse">
            </connection-api-test-component>


            <div class="col-md-8">

                <div v-if="isLoader" class="d-flex justify-content-center">
                    <loader-component  class=""></loader-component>
                </div>

                <alert-component type="success" v-if="this.cookie_send_passs_email">
                    <template  v-slot:content>
                        <h6>Pronto, já enviamos um link para seu e-mail, basta você clicar nele e alterar a sua senha.</h6>
                    </template>
                </alert-component>

                <div class="card mt-5"  v-if="status!==200" >
                    <div class="card-header">Resetar Senha</div>

                    <div class="card-body">

                        <form method="POST"  :action="this.route_password_email" @submit.prevent="action($event)">
                            <input type="hidden" name="_token" :value="csrf_token">

                            <div class="row mb-3">
                                <label for="email" class="col-md-4 col-form-label text-md-end">E-mail</label>

                                <div class="col-md-6">
                                    <input id="email" type="text" class="form-control" name="email" value=""
                                           autocomplete="email" autofocus v-model="email" @keyup="setCookieSendPasssEmail()">
                                    <alert-error-message-component :mesage="error" v-if="error"> </alert-error-message-component>
                                </div>
                            </div>

                            <div class="row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" class="btn btn-primary">
                                        Enviar Link
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!--route('password.email')-->

<script>
import 'jquery.cookie/jquery.cookie'

export default {
    name: "EmailComponent",
    props:['csrf_token', 'api_url', 'route_password_email'],
    data(){
       return {
           email : '',
           status: '',
           error : '',
           cookie_send_passs_email : false,
           isLoader : false
       }
    },
    methods:{

        setCookieSendPasssEmail(){
            $.removeCookie('send_pass_email');
            this.cookie_send_passs_email = false;
        },

       async action(e){

            if(this.email === ''){
                this.error = 'O campo e-mail é obrigatório';
                return ;
            }

            if(this.isEmail(this.email) === false){
                this.error = 'O campo e-mail é inválido';
                return ;
            }

            let url = this.api_url+'/'+this.email

           await axios.get(url).then(response =>{
                this.isLoader = true;
                if(!response.data.status){
                    this.error = response.data.message;
                    this.isLoader = false;
                    return ;
                }
                this.status =  response.status
                $.cookie('send_pass_email', true)
                e.target.submit();
            }).catch(error=>{

                $.cookie('send_pass_email', false)

                this.$store.state.errorMessageResponse = error.message;

                this.status = error.status
                this.error = error.message;
            })
        },
    },
    mounted() {
        this.cookie_send_passs_email  = $.cookie('send_pass_email')
        $.removeCookie('send_pass_email');
    },
}
</script>

<style scoped>

</style>
